/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S8_I1Inputs */

const tr_kullanim_s8_i1 = /** @type {(inputs: Kullanim_S8_I1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TLS 1.3 üzerinden tüm trafik şifrelenir.`)
};

const en_kullanim_s8_i1 = /** @type {(inputs: Kullanim_S8_I1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All traffic is encrypted over TLS 1.3.`)
};

const de_kullanim_s8_i1 = /** @type {(inputs: Kullanim_S8_I1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der gesamte Datenverkehr wird über TLS 1.3 verschlüsselt.`)
};

const ru_kullanim_s8_i1 = /** @type {(inputs: Kullanim_S8_I1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Весь трафик шифруется по TLS 1.3.`)
};

/**
* | output |
* | --- |
* | "All traffic is encrypted over TLS 1.3." |
*
* @param {Kullanim_S8_I1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s8_i1 = /** @type {((inputs?: Kullanim_S8_I1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S8_I1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s8_i1(inputs)
	if (locale === "de") return de_kullanim_s8_i1(inputs)
	if (locale === "ru") return ru_kullanim_s8_i1(inputs)
	return tr_kullanim_s8_i1(inputs)
});